import { Box, Typography } from '@mui/material';
import { useCallback } from 'react';
import { UserInfo } from 'shared/types';
import { PfdFormFileUploadField } from './pdf-form-file-upload-field';
import { useUploadPdfFiles } from '../shared/mutations/use-upload-pdf-files';
import { FormProvider, useForm } from 'react-hook-form';
import { USER_GUIDE_PDF } from 'shared/constants';

interface UserMappingListPageProps {
  user: UserInfo;
}

export interface PdfUploadFormData {
  files: FileList | null;
}

export function UploadPDFPage({ user }: UserMappingListPageProps) {
  const uploadPdfMutation = useUploadPdfFiles();

  const methods = useForm({
    defaultValues: {
      files: null,
    },
  });

  const onSubmit = useCallback(
    async (data: PdfUploadFormData) => {
      const formData = new FormData();
      const fileToUpload = data.files ? [data.files[0]] : [];
      formData.append('file', new File(fileToUpload, USER_GUIDE_PDF));

      await uploadPdfMutation.mutateAsync(formData);

      methods.resetField('files');
    },
    [uploadPdfMutation, methods]
  );

  return (
    <FormProvider {...methods}>
      <Box component='form' id='upload-pdf' onSubmit={methods.handleSubmit(onSubmit)}>
        <Box display={'flex'} alignItems={'center'} flexDirection={'column'}>
          <Box pt={3} pb={2}>
            <Typography variant='h5'>Upload User Guide</Typography>
          </Box>
          <PfdFormFileUploadField
            name={'files'}
            accept={'application/pdf'}
            rules={{
              required: {
                message: 'PDF Selection is required.',
                value: true,
              },
            }}
          />
        </Box>
      </Box>
    </FormProvider>
  );
}
